export default __webpack_public_path__ + "static/media/cfjp02.77ca0cd2.png";